'use strict';

function LoanOverviewPaidOff() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._moneyModelPath = 'money.loans';

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._setComputedVariables();
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('paid_off_amount');
    this.presenter.removeComputedVariable('paid_off_date');

    this._super();
  };

  this._setComputedVariables = function () {
    // TODO: Overview class?
    this.presenter.addComputedVariable('paid_off_amount', [this._moneyModelPath + '.loans[0].amount'], function (val) {
      return val;
    });

    this.presenter.addComputedVariable('paid_off_date', [this._moneyModelPath + '.loans[0].paid_off_at'], function (val) {
      return moment(val).format('MMM DD, YYYY') + '.';
    });
  };
}